import { useQuery } from '@tanstack/react-query';
import { FlowLogsService } from '../service/FlowLogsService';

export const useFlowLogs = (flowId: string, page: number, limit: number = 25) => {
  return useQuery({
    queryKey: ['flow-logs', flowId, page, limit],
    queryFn: async () => {
      const response = await FlowLogsService.getFlowLogs(flowId, page, limit);
      return response;
    },
    enabled: !!flowId,
  });
};

export const useFlowLog = (id: string) => {
  return useQuery({
    queryKey: ['flow-log', id],
    queryFn: async () => {
      const response = await FlowLogsService.getFlowLog(id);
      return response;
    },
    enabled: !!id,
  });
};

